"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BookingData = void 0;
var BookingData = /** @class */ (function () {
    function BookingData() {
    }
    return BookingData;
}());
exports.BookingData = BookingData;
//# sourceMappingURL=BookingData.js.map